export class PagesResult {
  url!: string;
  title!: string;
  domain!: string;
  content!: string;

  constructor(data: Partial<PagesResult> = {}) {
    Object.assign(this, data);
  }
}
